import React, { useRef, useState, useEffect } from "react";

export default function Scrollbar({ parentRef }) {
  const [scrollPercent, setScrollPercent] = useState(0);
  const [scrollWidthPercent, setScrollWidthPercent] = useState(0);

  const handleScroll = () => {
    const containerWidth = parentRef.current.scrollWidth;

    let progress = parentRef.current.scrollLeft / (containerWidth - parentRef.current.offsetWidth);
    let handleWidth = (parentRef.current.offsetWidth / containerWidth) * 100;
    let left = (100 - handleWidth) * progress;
    setScrollPercent(left);
    setScrollWidthPercent((100 * parentRef.current.offsetWidth) / containerWidth);
  };

  useEffect(() => {
    parentRef.current.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleScroll);
    return () => {
      window.removeEventListener("resize", handleScroll);
    };
  }, []);

  useEffect(() => {
    // wait 100ms so scrollwidth works properly
    setTimeout(() => {
      setScrollWidthPercent((100 * parentRef.current?.offsetWidth) / parentRef.current.scrollWidth);
    }, 100);
  }, []);

  if (scrollWidthPercent < 100) {
    return (
      <div className="scroll-bar">
        <div
          className="handle"
          style={{ width: scrollWidthPercent + "%", left: scrollPercent + "%" }}
        ></div>
      </div>
    );
  }
}
